<template>
  <div class="table-active row recursive-row">
    <div class="col-sm-9 ellipsis-text align-self-center">
      <indented-span :level="indentationLevel" >
        <button v-if="hasToggle" class="badge badge-light badge-sm badge-toggle align-self-center" @click="toggleDropdown" >
          <font-awesome-icon :icon="dropdownIcon" />
        </button>
        <span :class="{ 'text-success': searchMatch, 'font-weight-bold': searchMatch }">{{ group.name }} </span>
        <active-tag class="d-md-none" :isActive="group.is_active" />
      </indented-span>
    </div>
    <active-column :isActive="group.is_active" />
    <div class="col-sm-2 text-right align-self-center">
      <button class="btn btn-sm" @click="selectGroup">Select</button>
    </div>
  </div>
</template>

<script>
import IndentedSpan from '../IndentedSpan.vue';
import ActiveTag from '../Tags/ActiveTag.vue';
import ActiveColumn from './ActiveColumn.vue';
import config from '../../constants/config';

export default {
  components: {
    IndentedSpan,
    ActiveTag,
    ActiveColumn
  },
  name: 'GroupRow',
  props: {
    group: Object,
    level: Number,
    searchTerm: String,
    showDropdown: Boolean,
    searchMatchInChild: Boolean,
    pageType: String
  },
  methods: {
    toggleDropdown() {
      this.$emit('toggleDropdown');
    },
    selectGroup() {
      this.$store.commit('group/selectGroup', this.group);
      this.$bvModal.show(config.GROUP_MODAL_ID);
    }
  },
  computed: {
    dropdownIcon() {
      return this.showDropdown ? 'angle-down' : 'angle-right';
    },
    hasToggle() {
      return this.hasChildren && (!this.searchTerm || this.searchMatchInChild);
    },
    hasChildren() {
      return (this.group.children && this.group.children.length > 0) ||
        (this.isUsersPage && this.group.users && this.group.users.length > 0) ||
        (this.isLicensePage && this.group.pools && this.group.pools.length > 0);
    },
    indentationLevel() {
      return this.level > 0 ? (this.level + 1) : 0;
    },
    searchMatch() {
      return this.searchTerm &&
        this.group.name.toLowerCase().includes(this.searchTerm.toLowerCase());
    },
    isUsersPage() {
      return this.pageType == config.USERS_PAGE;
    },
    isLicensePage() {
      return this.pageType == config.LICENSES_PAGE;
    }
  },
  watch: {
    searchTerm(newTerm) {
      if (this.searchMatch) {
        this.$emit('searchFound', newTerm);
      }
    }
  }
};
</script>
